/**
 * @generated SignedSource<<0fb47c6902c9a862ad347a02eb2e7225>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TakingOverEmployeesType = "no" | "unknown" | "yes";
export type businessTakeoverEmployeeQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessTakeoverEmployeeQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly hasTakingOverEmployees: TakingOverEmployeesType | null | undefined;
      readonly takingOverEmployees: ReadonlyArray<{
        readonly attrYears: ReadonlyArray<string>;
        readonly birthday: string | null | undefined;
        readonly ieNm: string;
        readonly indvTin: string;
      }> | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
};
export type businessTakeoverEmployeeQuery = {
  response: businessTakeoverEmployeeQuery$data;
  variables: businessTakeoverEmployeeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasTakingOverEmployees",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SurveyEmployee",
            "kind": "LinkedField",
            "name": "takingOverEmployees",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "indvTin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ieNm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attrYears",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessTakeoverEmployeeQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessTakeoverEmployeeQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d7d2ebef2111dec4bd693e78546c9037",
    "id": null,
    "metadata": {},
    "name": "businessTakeoverEmployeeQuery",
    "operationKind": "query",
    "text": "query businessTakeoverEmployeeQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      hasTakingOverEmployees\n      takingOverEmployees {\n        indvTin\n        ieNm\n        birthday\n        attrYears\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "69dc02483a060dc8e7011a56a3b37f6b";

export default node;
